exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@page{margin:20mm 15mm}@media print{body{margin:0!important}#page-top{background:none!important;padding-top:15px!important}#lightcase-info,.image-facilities,.rotate-button,body>:not(#lightcase-case){display:none!important}#lightcase-case{position:static;margin:0!important;width:100%!important;text-align:center}.lightcase-contentInner{width:100%!important;height:100%!important}.lightcase-content{text-align:center}.image-holder{display:block;overflow:visible}.image-holder img{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a1eca1a","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/admin/components/VLightcaseHolder.vue
// module id = Qi1d
// module chunks = 1 2